export const INITAL_SENSORS = {
  hubId: null,
  hub: null,
  devices: [
    {
      defaultName: "SquidZigBee",
      name: "SquidZigBee",
      displayName: "Lilli hub",
      image: "/images/installation/hub/hub.png",
      alt: "Lilli hub with power cord attached to the hub",
      splinePNG: "/images/installation/spline/hub.png",
      online: false,
      eui: "0015BC002C11256E",
      label: "h1",
      id: 0,
    },
    {
      defaultName: "Smart Plug Mini UK",
      name: "Kitchen/Appliance/Power",
      displayName: "Smart plug",
      online: false,
      label: "p1",
      image: "/images/installation/smart_plug/plug.png",
      splinePNG: "/images/installation/spline/plug.png",
      id: 6,
      locationRequired: true,
      locationOptions: [
        { value: "kettle", label: "Kettle" },
        { value: "microwave", label: "Microwave" },
        { value: "toaster", label: "Toaster" },
        { value: "coffee maker", label: "Coffee maker" },
        { value: "other", label: "Other" },
      ],
    },
    {
      defaultName: "Motion Sensor Mini",
      name: "Hall/Wall/Motion",
      displayName: "Motion sensor",
      image:
        "/images/installation/motion/motion_sensor_battery_high_contrast.png",
      splinePNG: "/images/installation/spline/motion.png",
      online: false,
      label: "m1",
      locationRequired: true,
      locationOptions: [
        { value: "hallway", label: "Hallway" },
        { value: "stairs", label: "Stairs" },
        { value: "living room", label: "Living Room" },
        { value: "kitchen", label: "Kitchen" },
        { value: "other", label: "Other" },
      ],
      id: 1,
    },
    {
      defaultName: "Motion Sensor Mini",
      name: "Bathroom/Wall/Motion",
      displayName: "Bathroom sensor",
      online: false,
      image:
        "/images/installation/motion/motion_sensor_battery_high_contrast.png",
      splinePNG: "/images/installation/spline/motion.png",
      locationRequired: true,
      locationOptions: [
        { value: "Bath/Shower and Toilet", label: "Bath/Shower and Toilet" },
        { value: "Bath/Shower only", label: "Bath/Shower only" },
        { value: "toilet only", label: "Toilet only" },
      ],
      label: "m2",
      id: 2,
    },
    {
      defaultName: "Motion Sensor Mini",
      name: "Bedroom/Wall/Motion",
      displayName: "Bedroom sensor",
      online: false,
      description:
        "The sensor should be placed facing the entrance/exit to the bedroom and not facing the bed. It can be placed outside the bedroom.",
      image:
        "/images/installation/motion/motion_sensor_battery_high_contrast.png",
      splinePNG: "/images/installation/spline/motion.png",
      label: "m3",
      id: 3,
      locationRequired: true,
      locationOptions: [
        {
          value: "Inside bedroom, facing the entrance",
          label: "Inside bedroom, facing the entrance",
        },
        {
          value: "Outside bedroom, facing entrance",
          label: "Outside bedroom, facing entrance",
        },
        {
          value: "Facing the bed (not recommended)",
          label: "Facing the bed (not recommended)",
        },
        {
          value: "bed skirting",
          label: "Bed skirting",
        },
        {
          value: "Inside bedroom, not facing the bed",
          label: "Inside bedroom, not facing the bed",
        },
        { value: "other", label: "Other" },
      ],
    },
    {
      defaultName: "Window Sensor",
      name: "Hall/Main/Door",
      displayName: "Main door sensor",
      online: false,
      label: "d1",
      splinePNG: "/images/installation/spline/door.png",
      id: 4,
      locationRequired: true,
      locationOptions: [
        { value: "front door", label: "Front door" },
        { value: "back door", label: "Back door" },
      ],
    },
    {
      defaultName: "Window Sensor",
      name: "Kitchen/Fridge/Door",
      displayName: "Fridge sensor",
      splinePNG: "/images/installation/spline/door.png",
      online: false,
      label: "d2",
      locationRequired: true,
      locationOptions: [
        { value: "fridge", label: "Fridge" },
        { value: "cupboard", label: "Cupboard" },
        { value: "other", label: "Other" },
      ],
      id: 5,
    },
  ],
};
